import { render, staticRenderFns } from "./DetailTable.vue?vue&type=template&id=0fce176b&scoped=true"
import script from "./DetailTable.vue?vue&type=script&lang=js"
export * from "./DetailTable.vue?vue&type=script&lang=js"
import style0 from "./DetailTable.vue?vue&type=style&index=0&id=0fce176b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fce176b",
  null
  
)

export default component.exports